import { quickID, type BiblePassageContent } from '@soulhx/fs-common';
import React from 'react';

interface IAllCaps {
  items: BiblePassageContent[];
}
export const AllCaps = ({ items }: IAllCaps) => {
  const refinedItems = items.filter((i) => i.type === 'text');

  return refinedItems.map((item) => {
    if (item.type !== 'text') return;

    return (
      <span key={quickID()}>
        <span style={{ textTransform: 'uppercase' }}>{item.text?.toLocaleUpperCase().substring(0, 1)}</span>
        <span style={{ textTransform: 'uppercase', fontSize: '1.3ex' }}>
          {item.text?.toLocaleUpperCase().substring(1, item.text.length)}
        </span>
      </span>
    );
  });
};
